import { Layout, SlideoutDecorator, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutDistanceRouteDetails } from "./autogen/AutogenLayoutDistanceRouteDetails";
import { ModelRow } from "@mcleod/core";

export class DistanceRouteDetails extends AutogenLayoutDistanceRouteDetails {

    override onLoad(): void {
    }

    tableRoutesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        this.convertNestedDataToModelRow(tableRow.data);
        const nestedTable = tableRow.findComponentById("tableRouteDetails");
        if (nestedTable) {
            nestedTable.displayData(null, tableRow.data.get("route_details"), null);
        }
    }

    convertNestedDataToModelRow(modelRow: ModelRow) {
        if (modelRow ==  null || modelRow["_convertedNestedData"]) {
            return;
        }

        const routeDetails = modelRow.get("route_details");
        if (routeDetails == null) {
            return;
        }

        modelRow["_convertedNestedData"] = true;
        const detailModelRows = routeDetails.map((routeDetail: any) => new ModelRow("", false, routeDetail));
        modelRow.set("route_details", detailModelRows);
    }

    static showSlideout(props: any) {
        const { sourceStops, source, type, method, hazmatType } = props;
        const self = Layout.getLayout("lme/dispatch/DistanceRouteDetails") as DistanceRouteDetails;

        new SlideoutDecorator({
            layout: self,
            fillHeight: true,
            width: "40%",
            title: "Route Reports",
            doAfterSlideIn: () => {
                // Sort sourceStops.data by order_sequence
                const sortedStops = sourceStops.data.sort(
                    (a: any, b: any) => a.data.order_sequence - b.data.order_sequence
                );

                self.addRouteDetails(sortedStops, hazmatType);
                self.addInStateDistances(sortedStops, source, type, method, hazmatType);
            }
        });
    }

    private addInStateDistances(sortedStops: any, source: any, type: any, method: any, hazmatType: any) {
        // Create a list of city IDs from sortedStops (duplicates allowed)
        const cityIds: number[] = [];
        sortedStops.forEach((stop: any) => {
            cityIds.push(stop.data.city_id);
        });

        this.sourceInStateDistance.search({
            city_ids: cityIds, // Pass the list of city IDs
            source: source,
            type: type,
            method: method,
            hazmat_type: hazmatType
        });
    }

    private addRouteDetails(sortedStops: any, hazmatType: any) {
        this.sourceRoutes.search({
            sorted_stops: sortedStops, // Pass the list of sorted stops by sequence number
            hazmat_type: hazmatType
        });
    }
}
